var React = require('react');

function IconArrowDown (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Raggruppa_5","data-name":"Raggruppa 5","transform":"translate(645.589 517.004) rotate(180)"},[React.createElement("path",{"id":"Tracciato_26","data-name":"Tracciato 26","d":"M0,0,20.2,18.18,40.316,0","transform":"translate(644.92 490.909) rotate(180)","fill":"none","stroke":"#fff","strokeWidth":"2","key":0}),React.createElement("line",{"id":"Linea_39","data-name":"Linea 39","x1":"0.177","y2":"44.21","transform":"translate(624.604 472.79)","fill":"none","stroke":"#fff","strokeWidth":"2","key":1})]));
}

IconArrowDown.defaultProps = {"width":"41.655","height":"45.621","viewBox":"0 0 41.655 45.621"};

module.exports = IconArrowDown;

IconArrowDown.default = IconArrowDown;
